import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { DropDownMultiCheck } from "../DropDownMultiCheck";

export default function SeniorityLevel(params) {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  const [seniorityLevels, setSeniorityLevels] = useState([]);

  useEffect(
    () => CommonService.getAllSeniorityLevels().then((data) =>
    setSeniorityLevels(data)
      ),
    []
  );

  function setSelectedSeniorityLevelOptions(list) {
    setSearchObject({ ...searchObject, seniorityLevels: list });
  }
  
  return (
    <fieldset>
      <legend>{t("Seniority Level")}</legend>
      <DropDownMultiCheck
        dataList={seniorityLevels}
        selecteds={searchObject.seniorityLevels}
        setSelecteds={setSelectedSeniorityLevelOptions}
      />
    </fieldset>
  );
}
